import { axiosInstanceMultipart } from "../host";

export const HttpRequestHubMultipart = (config: any) => {
  return axiosInstanceMultipart(config);
};
